// import crud action
import { platformsActions as platforms } from './platforms/actions';
import { nichesActions as niches } from './niches/actions';
import { commentsActions as comments } from './comments/actions';
import { notificationsActions as notifications } from './notifications/actions';
import { ordersActions as orders } from './orders/actions';

export default {
  // actions here
  platforms,
  niches,
  comments,
  notifications,
  orders,
};
